export class MenuLabel
{
    public static Home = 'Home';
    public static HomeDashboard = 'Dashboard';
    public static HomeSystemStatus = 'System Status';

    public static OpsTower = 'Ops Tower';
    public static OpsDashboard = 'Dashboard';
    public static OpsLiveMap = 'Live Map';
    public static OpsHeatMap = 'HeatMap';
    public static OpsZonesMap = 'Zones Map';
    public static OpsBookings = 'Bookings';
    public static OpsRide = 'Ride';
    public static OpsSend = 'Send';
    public static Xpass = 'Xpass';
	public static Tour = 'Tour';
    public static OpsDelivery = 'Delivery';
    public static OpsRent = 'Rent';
    public static OpsPetTaxi = 'Pet Taxi';
    public static OpsTaxiRides = 'Taxi';
    public static OpsTransfers = 'Transfers';
    public static OpsMoto = 'Moto';
    public static OpsCars = 'Cars';
    public static OpsAdmin = 'Admin';
    public static OpsReports = 'Reports';
    public static OpsDrivers = 'Drivers';
    public static OpsCustomers = 'Customers';
    public static OpsOperators = 'Operators';
    public static OpsDailyStatistics = 'Daily Statistics';
    public static OpsDriverPerformance = 'Driver Performance';
	public static OpsTaxiDriverPerformance = 'Taxi Driver Performance';
    public static OpsUsers = 'Users';
    public static OpsQuestReport = 'Quest Report';

    public static Application = 'Application';
    public static ApplicationRegistration = 'Registration';
    public static EatsPartner = 'Eats Partner';
    public static MartsPartner = 'Marts Partner';

    public static Marketing = 'Marketing';
    public static MarketingAllPromotions = 'All Promotions';
    public static PromotionMaterials = 'Promotion Materials';

    public static Comms = 'Comms';
    public static CommsOperators = 'Operators';
    public static CommsDrivers = 'Drivers';
    public static CommsCustomers = 'Customers';
    public static CommsFeedbacks = 'Feedbacks';

    public static Report = 'Report';
    public static ReportDrivers = 'Drivers';
    public static ReportCustomers = 'Customers';
    public static ReportRevenue = 'Revenue';
    public static ReportDisbursements = 'Disbursements';

    public static AccountingDashboard = 'Dashboard';
    public static AccountingPayout = 'Payout';
    public static AccountingCashflowSummary = 'Cashflow Summary';
    public static AccountingXenditTransactions = 'Xendit Transactions';

    public static Bookings = 'Bookings';
    public static Reports = 'Reports';
    public static Drivers = 'Drivers';
    public static Merchants = 'Merchants';
    public static Disciplinary = 'Disciplinary';
    public static Dashboard = 'Dashboard';
    public static BroadcastMessage = 'Broadcast Message';
    public static OfflineMarketing = 'Offline Marketing';
    public static Events = 'Events';
    public static XpressAppMarketing = 'App Marketing';
    public static SystemStatus = 'System Status';
    public static UserManagement = 'User Management';
    public static Maps = 'Maps';
    public static Security = 'Security';
    public static VehicleAndFares = 'Vehicle and Fares';
    public static Coding = 'Coding';
    public static Accounting = 'Accounting';
    public static Users = 'Users';
    public static Eats = 'Eats';
    public static Mart = 'Mart';
    public static Promotions = 'Promotions';
    public static PromoBudgets = 'Promo Budgets';
    public static PromoSponsors = 'Promo Sponsors';
    public static Advertisements = 'Advertisements';
    public static CustomerQuest = 'Customer Quest';
    public static IncentiveQuest = 'Incentive Quest';

    public static Driver = 'Driver';
    public static Registration = 'Registration';
    public static DraftRegistration = 'Draft Registration';
    public static Assessment = 'Assessment';
    public static ActiveDrivers = 'Active Drivers';
    public static CampaignDrivers = 'Campaign Drivers';
    public static CampaignRiders = 'Camp. Riders';
    public static Transactions = 'Transactions';
    public static Xpress50 = 'Xpress 50';
    public static Xpress50Riders4W = '4RXP';
    public static Xpress2WEV = '2W EV';
	public static Xpress4WEV = '4W EV';
	public static Xpress4WEVBataan = 'Bataan Full-EV Drivers';
    public static AllanGroup = 'Allan Group';
    public static NiloGroup = 'Nilo Group';
    public static LoopPassDrivers = 'Loop Pass';

    public static Overview = 'Overview';
    public static Facebook = 'Facebook';
    public static Instagram = 'Instagram';
    public static Linkedin = 'Linkedin';
    public static GoogleAnalytics = 'Google Analytics';
    public static AppDownloads = 'App Downloads';
    public static Operators = 'Operators';
    public static Customers = 'Customers';
    public static Feedbacks = 'Feedbacks';
    public static Inquiries = 'Inquiries';

    public static Taxi = 'Taxi';
    public static ConneX = 'ConneX';
    public static TaxiVehicles = 'Taxi Vehicles';
    public static ConneXVehicles = 'ConneX Vehicles';
    public static ConnexBookings = 'Bookings';
    public static ConnexRouteConfiguration = 'Configuration';
    public static TourOperators = 'Tour Operators';
    public static RegistrationBeta = 'Registration (beta)';
    public static RegistrationBetaNew = 'Registration (v2)';
    public static Gph = 'GPH';
    public static Passenger2W = 'Passenger 2W';
    public static Passenger3W = 'Passenger 3W';
    public static Passenger4W = 'Passenger 4W';
    public static Delivery2W = 'Delivery 2W';
    public static Delivery4W = 'Delivery 4W';
    public static NewCases = 'New Cases';
    public static InProcess = 'In Process';
    public static Archived = 'Archived';
    public static Vehicles = 'Vehicles';
    public static Campaign3W = 'Campaign 3W';
    public static Campaign4W = 'Campaign 4W';
    public static User = 'User';
    public static TODAs = 'TODAs';
    public static XpressLocations = 'Xpress Locations';
    public static Calendar = 'Calendar';
    public static SuspendedUsers = 'Suspended Users';
    public static BlacklistedUsers = 'Blacklisted Users';
    public static CampaignUsers = 'Campaign Users';

    public static LGU = 'LGU';
    public static Campaigns = 'Campaigns';
    public static Ambassadors = 'Ambassadors';
    public static Influencers = 'Influencers';
    public static Marketing3rdPartyCompany = '3rd Party Company';

    public static DriverActivation = 'Driver Activation';
    public static UserActivation = 'User Activation';
    public static MerchantActivation = 'Merchant Activation';
    public static EmployeeEvent = 'Employee Event';
    public static DriverTraining = 'Driver Training';
    public static OtherEvents = 'Other Events';
    public static Assets = 'Assets';
    public static MarketingMaterial = 'Marketing Material';
    public static Perfomance = 'Perfomance';
    public static AllCampaigns = 'All Campaigns';
    public static Settings = 'Settings';
    public static Integration = 'Integration';
    public static DiscountsReport = 'Discounts Report';
	public static ReferralReport = 'Referral Report';

    public static Finance = 'Finance';
    public static Commerce = 'Commerce';
    public static Revenue = 'Revenue Report';
    public static CustomerWallet = 'Customer Xpay Wallet';
    public static DriverWallet = 'Driver Wallet';
    public static DriverCommerce = 'Driver Commerce';
    public static CustomerCommerce = 'Customer Commerce';
    public static Payout = 'Payout';
    public static CashflowSummary = 'Cashflow Summary';
    public static XenditTransactions = 'Xendit Transactions';
    public static Inventory = 'Inventory';
    public static Collection = 'Collection';
    public static GuaranteedPay = 'Guaranteed Pay';
    public static TopUps = 'Top Ups';
    public static CashOut = 'Cash Out';

    public static Playstore = 'Playstore';
    public static AppStore = 'App Store';

    public static AllUsers = 'All Users';
    public static RegionMapEditor = 'Region Map Editor';
    public static Roles = 'Roles';
    public static PasswordManagement = 'Password Management';
    public static UserAudit = 'User Audit';
    public static PlatformAlerts = 'Platform Alerts';
    public static SuspiciousActivities = 'Suspicious Activities';
    public static Vehicle = 'Vehicle';
    public static ETrike = 'E-Trike';
    public static Multicab = 'Multicab';
    public static Van = 'Van';
    public static Minibus = 'Minibus';

    public static Audit = 'Audit';
    public static Verification = 'Verification';
    public static ApplicationAudit = 'Application Audit';
    public static AuditHistory = 'Audit History';

    public static Customer = 'Customer';
    public static Owners = 'Owners';
    public static Invoices = 'Invoices';

    public static OperatorDashboard = 'Dashboard';

    public static OperatorReports = 'Reports';

    public static OperatorFinance = 'Finance';

    public static Employees = 'Employees';
    public static Catalogue = 'Catalogue';
    public static AppConfig = 'App Config';

    public static Orders = 'Orders';
    public static AllOrders = 'All Orders';
    public static FinanceReports = 'Finance';
    public static Locations = 'Locations';
    public static Store = 'Store';
    public static Menu = 'Menu';
    public static Help = 'Help';
    public static Insights = 'Insights';
    public static Feedback = 'Feedback';
    public static StoreEmployees = 'Store Employees';
    public static PartnerEmployees = 'Partner Employees';
    public static AllProducts = 'All Products';
    public static Categories = 'Categories';
    public static Bundles = 'Bundles';
    public static Payouts = 'Payouts';
    public static NextPayout = 'Next Payout';
    public static StoreIdentity = 'Store Identity';
    public static RecommendedProducts = 'Recommended Products';
    public static CategoryOrder = 'Category Order';
    public static Stores = 'Stores';
    public static Groups = 'Groups';
    public static AllPromotions = 'All Promotions';
    public static Performance = 'Performance';
    public static RecommendedPromo = 'Recommended Promo';
    public static CreateCampaign = 'Create Campaign';
    public static Operations = 'Operations';
    public static Products = 'Products';
    public static Reviews = 'Reviews';
    public static BusinessInfo = 'Business Info';
    public static LegalDocuments = 'Legal Documents';
    public static PayoutAccount = 'Payout Account';
    public static AuthorizedRepresentative = 'Authorized Representative';
    public static PartnershipTerms = 'Partnership Terms';

	public static VehicleUpgrades = 'Vehicle Upgrades';

	public static Experience = 'eXperience';
	public static ExperienceDashboard = 'Dashboard';
	public static ExperienceOperatorReg = 'Operator Reg';
	public static ExperienceListingReview = 'Listing Review';
	public static ExperienceBookingOversight = 'Booking Oversight';
	public static ExperienceCompliance = 'Compliance';
	public static ExperienceNotification = 'Notification';
	public static ExperienceSandbox = 'Sandbox';
	public static ExperienceListings = 'Experience Listings';
}
